import { render, staticRenderFns } from "./ediBaseWindow.vue?vue&type=template&id=9c1328a6&"
import script from "./ediBaseWindow.vue?vue&type=script&lang=js&"
export * from "./ediBaseWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c1328a6')) {
      api.createRecord('9c1328a6', component.options)
    } else {
      api.reload('9c1328a6', component.options)
    }
    module.hot.accept("./ediBaseWindow.vue?vue&type=template&id=9c1328a6&", function () {
      api.rerender('9c1328a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/leadPage/ediBaseWindow.vue"
export default component.exports